
import React, { useState } from 'react';
import {
    Button,
    Card,
    CardHeader,
    CardContent,
    Divider,

    Avatar,
    IconButton,
    Menu,
    MenuItem,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    Grid,
    Link,
    Stack,
    Alert,
    DialogTitle

} from '@mui/material';
import { useLocation, useNavigate, useParams } from 'react-router';
import { axiosFetch } from '../../../../utils/AxiosFetch';
import MoreVert from '@mui/icons-material/MoreVert';
import DeleteIcon from '@mui/icons-material/Delete';
import { useDispatch } from 'react-redux';
import { CustomizedSnackbar } from '../../../../shared/index';
import { SnackbarActions } from '../../../../redux/actions/snackbar.actions';
import { TimeConversion } from '../../../../utils/TimeConversion';
import { Close } from '@mui/icons-material';
import styled from '@emotion/styled';
const Comments = (props) => {



    var userDetails =
        localStorage.getItem("argus_user") !== null
            ? localStorage.getItem("argus_user")
            : null;

    var userType =
        userDetails !== null && JSON.parse(userDetails).usertype !== null
            ? JSON.parse(userDetails).usertype
            : "";
    var userid =
        userDetails !== null && JSON.parse(userDetails).userid !== null
            ? JSON.parse(userDetails).userid
            : "";

    const [anchorEl, setAnchorEl] = React.useState(null);
    const [openDialog, setOpenDialog] = useState(false);

    const { id } = useParams();
    const [commentId, setCommentId] = useState("");


    const open = Boolean(anchorEl);

    const navigate = useNavigate();
    const dispatch = useDispatch();


    const handleClick = (event, id) => {
        setCommentId(id);
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleComments = () => {
        props.toggleCommentsPopup(parseInt(id));
    }

    const openConfirmPopup = () => {
        setAnchorEl(null);
        setOpenDialog(true);
    };

    const closeConfirmPopup = () => {
        setOpenDialog(false);
    };

    const deleteComment = () => {
        axiosFetch({
            method: "delete",
            url: `/OKRs/okr/comment/${commentId}`
        })
            .then((res) => {
                if (res.status === 200) {
                    setOpenDialog(false);
                    dispatch(SnackbarActions(true, "success", "Comment Deleted"));
                    props.loadComments();

                }
                else if (res.status === 401) {
                    navigate('/');
                }
            })
    }




    const BootstrapDialogTitle = (props) => {
        const { children, onClose, ...other } = props;

        return (
            <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
                {children}
                {closeConfirmPopup ? (
                    <IconButton
                        aria-label="close"
                        onClick={closeConfirmPopup}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <Close />
                    </IconButton>
                ) : null}
            </DialogTitle>
        );
    };

    // BootstrapDialogTitle.propTypes = {
    //     children: PropTypes.node,
    //     onClose: PropTypes.func.isRequired,
    // };
    return (
        <div className='argus-kr-comments kr-box'>
            <Grid container spacing={2}>
                <Grid item xs={12} sx={{ margin: "10px" }}>

                    {(props && props.basic_OkrDetails !== undefined && props.basic_OkrDetails !== null && props.basic_OkrDetails.isArchived !== undefined && props.basic_OkrDetails.isArchived) ? "" : userType === "Admin"
                        || (props && props.basic_OkrDetails !== undefined && props.basic_OkrDetails !== null && props.basic_OkrDetails.createdby !== undefined && props.basic_OkrDetails.createdby === userid)
                        || (props && props.basic_OkrDetails !== undefined && props.basic_OkrDetails !== null && props.basic_OkrDetails.users !== undefined && props.basic_OkrDetails.users.owners.length !== 0 && props.basic_OkrDetails.users.owners.filter(owner => owner.id === userid).length !== 0)
                        || (props && props.basic_OkrDetails !== undefined && props.basic_OkrDetails !== null && props.basic_OkrDetails.users !== undefined && props.basic_OkrDetails.users.participants.length !== 0 && props.basic_OkrDetails.users.participants.filter(participant => participant.id === userid).length !== 0) ? <Button className='theme-btn' style={{ marginBottom: "15px" }} onClick={handleComments}>
                        Add Comment
                    </Button> : ""}
                </Grid>
            </Grid>
            <Grid container spacing={2}>

                {props && props.comments !== undefined && props.comments.length === 0 ? (<><Stack sx={{ width: '100%', margin: "0 10px" }} spacing={2}>
                    <Alert severity="error">No Comments Available</Alert></Stack></>) : props.comments.map((comment) => {
                        return (
                            <Grid item xs={12}>
                                <Card sx={{ position: "relative", padding: "10px" }}>
                                    <CardHeader avatar={<Avatar aria-label="recipe">
                                        <Link to={`/users-profile/${comment.createdBy}`}> {comment.createdByName !== null ? comment.createdByName.charAt(0) : ""}</Link>
                                    </Avatar>}
                                        action={<MoreVert className='option-menu' onClick={(e) => handleClick(e, comment.id)} />}
                                        title={comment.createdByName !== null ? <Link className="comment-created" to={`/users-profile/${comment.createdBy}`}>{comment.createdByName}</Link> : ""}
                                        subheader={comment.createdDate !== null ? "created on " + TimeConversion(comment.createdDate, 2) : ""} />
                                    <Divider />
                                    <CardContent sx={{ marginTop: "10px" }}> {comment.comment !== null ? comment.comment : null}</CardContent>
                                </Card>
                                {/* <List>
                            <ListItem alignItems="flex-start">
                                <ListItemAvatar className="comments-avtar">
                                    
                                </ListItemAvatar>
                                <ListItemText

                                    className="commnets-title"
                                    secondary={
                                        <React.Fragment>
                                            <Typography
                                                sx={{ display: 'inline' }}
                                                component="span"
                                                variant="body2"
                                                color="text.primary"
                                            >
                                                
                                            </Typography>
                                            <br />
                                            {comment.comment !== null ? comment.comment : null}
                                        </React.Fragment>
                                    }
                                />
                                <ListItemIcon>

                                </ListItemIcon>

                            </ListItem>
                        </List> */}
                            </Grid>
                        )
                    })}
            </Grid>
            <Dialog
                open={openDialog}
                onClose={closeConfirmPopup}
                aria-describedby="alert-dialog-slide-description"
                className="small-info-popup"
                fullWidth="sm"
                maxWidth="sm"
            >
                <BootstrapDialogTitle className="modal-heading"> Are you sure you want to delete?</BootstrapDialogTitle>
                {/* <Divider /> */}
                <DialogContent>
                    {/* <DialogContentText id="alert-dialog-slide-description">
                        Are you sure you want to delete?
                    </DialogContentText> */}
                </DialogContent>
                <Divider />
                <DialogActions>
                    <Button onClick={closeConfirmPopup} className="no-btn theme-btn cancel-btn">No</Button>
                    <Button onClick={deleteComment} className="yes-btn theme-btn">Yes</Button>
                </DialogActions>
            </Dialog>


            <Menu
                id="demo-positioned-menu"
                aria-labelledby="demo-positioned-button"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
            >

                <MenuItem> <IconButton onClick={openConfirmPopup}>
                    <DeleteIcon /> Delete
                </IconButton></MenuItem>
            </Menu>

            <CustomizedSnackbar />
        </div>
    )
}

export default Comments;